import axios from "axios";
import moment from "moment";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useParams, useNavigate, Link } from "react-router-dom";
import Select from "react-select";

import {
  GetSinglePermohonan,
  reset,
} from "../../../features/permohonan/PermohonanSlice";

import {
  Card,
  Button,
  Form,
  Col,
  Row,
  Alert,
} from "@themesberg/react-bootstrap";

import AdminLayout from "../../../layout/admin";
import { Header } from "../../../components/admin";

import {
  hideLoadingDialog,
  showAlertDialog,
  showFailedDialog,
  showLoadingDialog,
  showSuccessDialog,
} from "../../../helpers/dialog.helper";
import BASE_URL from "../../../api";
import { UserContext } from "../../../utils/ProtectedRoute";
import {
  GetAllLayananDropdown,
  reset as resetLayanan,
} from "../../../features/LayananSlice";
import {
  GetAllLayananDokumenUserByLayananID,
  reset as resetLayananDokumen,
} from "../../../features/layananDokumenSlice";
import {
  GetAllLayananFieldByLayananID,
  reset as resetLayananField,
} from "../../../features/LayananFieldSlice";

import {
  faEdit,
  faEye,
  faTimesCircle,
} from "@fortawesome/free-regular-svg-icons";
import {
  faChevronCircleLeft,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ModalPermohonanTimeline from "./../../../components/modal/ModalPermohonanTimeline/index";
import ModalVerificationPermohonanDialog from "./../../../components/modal/ModalVerificationPermohonanDialog/index";

const FormPembayaranVAPage = () => {
  const [dataPermohonan, setDataPermohonan] = useState({
    nim: "",
    nama: "",
  });
  const [dokumenList, setDokumenList] = useState([]);
  const [fieldList, setFieldList] = useState([]);

  // get user data from context to validate which menu has shown and hide
  // for the current user
  const { userData } = useContext(UserContext);

  const dispatch = useDispatch();
  const { data, isLoading, isError } = useSelector((state) => state.permohonan);

  const {
    data: dataLayanan,
    isLoading: isLoadingLayananList,
    isError: isErrorLayananList,
  } = useSelector((state) => state.layanan);

  const {
    data: dataLayananDokumen,
    isLoading: isLoadingLayananDokumenList,
    isError: isErrorLayananDokumenList,
  } = useSelector((state) => state.layananDokumen);

  const {
    data: dataLayananField,
    isLoading: isLoadingLayananFieldList,
    isError: isErrorLayananFieldList,
  } = useSelector((state) => state.layananField);

  const param = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const token = localStorage.getItem("token");

  // on init (call once when the page has been loaded)
  useEffect(() => {
    // reset to trigger update UI
    // because, there is a useEffect that relies to this props
    setDataPermohonan({
      nim: "",
      nama: "",
    });
    // call api to fetch fakultas dropdown data
    dispatch(reset());
    dispatch(resetLayanan());
    dispatch(resetLayananDokumen());
    dispatch(GetAllLayananDropdown({ token }));
    if (id) {
      dispatch(GetSinglePermohonan({ id, token }));
    }
  }, [id, dispatch, token, navigate]);

  // init the model before send to Server, if any.
  // update the model if user role is meant for "MAHASISWA".
  useEffect(() => {
    const copyData = Object.assign(
      { ...data?.data },
      {
        nim: data?.data?.user?.nim || userData?.nim,
        nama: data?.data?.user?.nama || userData?.nama,
      }
    );
    if (copyData?.fields) {
      // batching data, cz setState can't use on loop func. they called 'lazy'
      setFieldList([...copyData?.fields]);
    }
    setDataPermohonan(copyData);
  }, [userData, data]);

  // UPDATE | 22/07/24 | the document has bind with the user now.
  useEffect(() => {
    const result = dataLayananDokumen?.data?.map((item, i) => ({
      id: item.id_userfieldn,
      id_user: item.id_user,
      id_dokumen: item.id_dokumen,
      dokumen: item.dokumen,
      status: item.status,
      is_deleted: item.is_deleted,
      dokumenFullPath: item.dokumenFullPath,
    }));
    setDokumenList([...(result || [])]);
  }, [dataLayananDokumen]);

  useEffect(() => {
    dispatch(resetLayananDokumen());
    dispatch(resetLayananField());
    if (dataPermohonan?.id_layanan) {
      dispatch(
        GetAllLayananFieldByLayananID({ token, id: dataPermohonan?.id_layanan })
      );
      dispatch(
        GetAllLayananDokumenUserByLayananID({
          token,
          id_layanan: dataPermohonan?.id_layanan,
          id_user: dataPermohonan?.id_user || userData?.id,
        })
      );
    }
  }, [dataPermohonan.id_layanan]);

  const handleSubmit = (e) => {
    e.preventDefault();

    // CHECK IF ALL THE FIELD IS ALREADY FILLED
    const hasMandatoryFieldEmpty = dataLayananField?.data?.find(
      (e) =>
        e.required &&
        !fieldList?.find((el) => el.id_field === e.id_field)?.value
    );
    if (hasMandatoryFieldEmpty) {
      showFailedDialog({
        title: "Oops!",
        msg: "Harap upload semua data yang dibutuhkan!",
      });
      return;
    }

    // CHECK IF ALL THE DOKUMEN IS ALREADY UPLOADED
    const hasMandatoryDocEmpty = dataLayananDokumen?.data?.find(
      (e) =>
        e.is_mandatory &&
        !dokumenList?.find((el) => el.id_dokumen === e.id_dokumen)?.dokumen
    );
    if (hasMandatoryDocEmpty) {
      showFailedDialog({
        title: "Oops!",
        msg: "Harap upload semua data yang dibutuhkan!",
      });
      return;
    }

    // for now, the update system is unavailable.
    // this is just for preparing.
    showAlertDialog({
      title: id ? "Update?" : "Simpan?",
      msg: `apakah anda yakin ingin ${
        id ? "mengupdate" : "menyimpan"
      } data ini?`,
      confirmButtonText: id ? "Update" : "Simpan",
      onConfirm: async () => {
        showLoadingDialog();
        try {
          let response;
          dataPermohonan.dokumen = dokumenList;
          dataPermohonan.field = fieldList;
          if (id) {
            response = await axios.put(
              `${BASE_URL}permohonan/${id}`,
              {
                ...dataPermohonan,
              },
              {
                headers: {
                  Authorization: token,
                },
              }
            );
          } else {
            response = await axios.post(
              `${BASE_URL}permohonan`,
              {
                ...dataPermohonan,
              },
              {
                headers: {
                  Authorization: token,
                },
              }
            );
          }
          console.log("RESPONSE : ", response);
          hideLoadingDialog();
          showSuccessDialog({
            title: "Berhasil!",
            msg: "Berhasil menyimpan data!",
          });
          const theID = response?.data?.data?.id;
          navigate(`/permohonan/detail/${theID}`);
        } catch (error) {
          console.log("ERROR", error);
          hideLoadingDialog();
          showFailedDialog({
            title: "Oops!",
            msg: error?.response?.data?.message || "Gagal menyimpan data!",
          });
        }
      },
    });
  };

  function getLayananList() {
    try {
      const result = dataLayanan?.data?.map((item, i) => ({
        value: item,
        label: item.nama,
      }));
      return result;
    } catch (error) {
      return [];
    }
  }

  // Function to update an item by ID
  const saveDokumenByIdDokumen = (id, newData) => {
    // check if the document is already save
    if (dokumenList.find((e) => e.id_dokumen === id)) {
      // Use map to create a new array with the updated item
      const updatedItems = dokumenList.map((dokumen) => {
        if (dokumen.id_dokumen === id) {
          dokumen = newData;
          // Return a new object with the updated ones
          return { ...dokumen };
        }
        // For other items, return them as they are
        return dokumen;
      });

      // Set the state with the updated items array
      setDokumenList(updatedItems);
    } else {
      setDokumenList([...dokumenList, newData]);
    }
  };

  // isRevised use by CREATOR who wants to resubmit their permohonan.
  const onAjukanClick = async (isRevised) => {
    const hasDokumenRevised = dokumenList?.find(
      (e) => e.status === null || e.status === "2"
    );
    if (isRevised) {
      if (hasDokumenRevised) {
        showFailedDialog({
          title: "Oops!",
          msg: "Mohon upload ulang file yang direvisi sebelum mengajukan ulang!",
        });
        return;
      }
    }
    showAlertDialog({
      title: isRevised ? "Ajukan Ulang?" : "Ajukan?",
      msg: `apakah anda yakin ingin mengajukan data ini?`,
      confirmButtonText: "Ajukan",
      onConfirm: async () => {
        showLoadingDialog();
        try {
          if (isRevised) {
            dataPermohonan.dokumen = dokumenList;
            await axios.post(
              `${BASE_URL}permohonan/ajukan_ulang/${id}`,
              {
                status: "1",
                id_layanan: dataPermohonan.id_layanan,
                dokumen: dokumenList,
              },
              {
                headers: {
                  Authorization: token,
                },
              }
            );
          } else {
            await axios.post(
              `${BASE_URL}permohonan/ajukan/${id}`,
              {
                ...dataPermohonan,
              },
              {
                headers: {
                  Authorization: token,
                },
              }
            );
          }
          hideLoadingDialog();
          showSuccessDialog({
            title: "Berhasil!",
            msg: "Berhasil mengajukan data!",
          });
          dispatch(reset());
          dispatch(GetSinglePermohonan({ id, token }));
        } catch (error) {
          console.log("ERROR", error);
          hideLoadingDialog();
          showFailedDialog({
            title: "Oops!",
            msg: error?.response?.data?.message || "Gagal menyimpan data!",
          });
        }
      },
    });
  };

  const onFileChange = async (file, mDokumen) => {
    if (file) {
      try {
        showLoadingDialog();
        const formData = new FormData();
        formData.append("file", file); // 'file' should match the backend key that accepts the file

        // You can also append additional data to the FormData if needed
        const requestObj = {
          id_transaksi: `${userData.id}-${mDokumen.nama_dokumen}-${Date.now()}`,
          id_dokumen: mDokumen.id_dokumen,
          nama_dokumen: mDokumen.nama_dokumen,
        };

        Object.entries(requestObj).map(([key, value]) => {
          formData.append(`${key}`, `${value}`);
        });

        const response = await axios.post(
          `${BASE_URL}user/upload_file_user`,
          formData,
          {
            headers: {
              Authorization: token,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        saveDokumenByIdDokumen(mDokumen.id_dokumen, response?.data?.data);
        hideLoadingDialog();
        showSuccessDialog({
          title: "Berhasil!",
          msg: "Berhasil menyimpan data!",
        });
      } catch (error) {
        console.log("ERROR", error);
        hideLoadingDialog();
        showFailedDialog({
          title: "Oops!",
          msg: error?.response?.data?.message || "Gagal menyimpan data!",
        });
      }
    }
  };

  return (
    <AdminLayout>
      {param.pathname.split("/")[2] === "detail" ? (
        <>
          <Header title="Detail Permohonan">
            <Button
              variant="outline-primary"
              size="sm"
              as={Link}
              to={`/permohonan/list`}
            >
              <FontAwesomeIcon icon={faChevronCircleLeft} className="me-2" />
              Kembali
            </Button>
          </Header>
        </>
      ) : param.pathname.split("/")[2] === "create" ? (
        <>
          <Header title="Buat Permohonan">
            <Button
              variant="outline-primary"
              size="sm"
              as={Link}
              to={`/permohonan/list`}
            >
              <FontAwesomeIcon icon={faChevronCircleLeft} className="me-2" />
              Kembali
            </Button>
          </Header>
        </>
      ) : param.pathname.split("/")[2] === "edit" ? (
        <>
          <Header title="Edit Permohonan">
            <Button
              variant="outline-primary"
              size="sm"
              as={Link}
              to={`/permohonan/list`}
            >
              <FontAwesomeIcon icon={faChevronCircleLeft} className="me-2" />
              Kembali
            </Button>
          </Header>
        </>
      ) : null}
      <Card border="light" className="shadow-sm mb-4">
        <FormPage
          id={id}
          dataPermohonan={dataPermohonan}
          setDataPermohonan={setDataPermohonan}
          dokumenList={dokumenList}
          fieldList={fieldList}
          setFieldList={setFieldList}
          handleSubmit={handleSubmit}
          formDisable={param.pathname.split("/")[2] === "detail" ? true : false}
          formDisableNotAdmin={userData?.id_role === "HA05"}
          onFileChange={onFileChange}
          onAjukanClick={onAjukanClick}
          isLoading={isLoading}
          isError={isError}
          isLoadingLayananList={isLoadingLayananList}
          dataLayanan={getLayananList()}
          isLoadingLayananDokumenList={isLoadingLayananDokumenList}
          dataLayananDokumen={dataLayananDokumen}
          isLoadingLayananFieldList={isLoadingLayananFieldList}
          dataLayananField={dataLayananField}
        />
      </Card>
    </AdminLayout>
  );
};

const FormPage = (props) => {
  const {
    id,
    isLoading,
    isError,
    dataPermohonan,
    setDataPermohonan,
    dokumenList,
    fieldList,
    setFieldList,
    handleSubmit,
    formDisable,
    formDisableNotAdmin,
    onFileChange,
    onAjukanClick,
    // Layanan
    isLoadingLayananList,
    dataLayanan,
    // Kategori Layanan
    isLoadingLayananDokumenList,
    dataLayananDokumen,
    // Kategori Layanan Field
    isLoadingLayananFieldList,
    dataLayananField,
  } = props;

  // get user data from context to validate which menu has shown and hide
  // for the current user
  const fileVerifInputRef = useRef(null);
  const { userData } = useContext(UserContext);
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();

  const [showModalTimeline, setShowModalTimeline] = useState(false);
  const [showVerifModal, setShowVerifModal] = useState(false);

  const onFileVerifChange = async (file) => {
    if (file) {
      try {
        showLoadingDialog();
        const formData = new FormData();
        formData.append("file", file); // 'file' should match the backend key that accepts the file

        const response = await axios.post(
          `${BASE_URL}permohonan/upload_file/${id}`,
          formData,
          {
            headers: {
              Authorization: token,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        hideLoadingDialog();
        showSuccessDialog({
          title: "Berhasil!",
          msg: "Berhasil menyimpan data!",
        });
        dispatch(reset());
        dispatch(GetSinglePermohonan({ id, token }));
      } catch (error) {
        console.log("ERROR", error);
        hideLoadingDialog();
        showFailedDialog({
          title: "Oops!",
          msg: error?.response?.data?.message || "Gagal menyimpan data!",
        });
      }
    }
  };

  const onClickVerify = async (status_approval, value) => {
    showLoadingDialog();
    try {
      if (id) {
        const response = await axios.post(
          `${BASE_URL}permohonan/verifikasi/${id}`,
          {
            status_approval,
            value,
          },
          {
            headers: {
              Authorization: token,
            },
          }
        );
        hideLoadingDialog();
        showSuccessDialog({
          title: "Berhasil!",
          msg: "Berhasil memverifikasi data!",
        });
        // refetch
        setShowVerifModal(false);
        dispatch(reset());
        dispatch(GetSinglePermohonan({ id, token }));
      } else {
        throw "id not found!";
      }
    } catch (error) {
      console.log("ERROR", error);
      hideLoadingDialog();
      showFailedDialog({
        title: "Oops!",
        msg: error?.response?.data?.message || "Gagal memverifikasi data!",
      });
    }
  };

  const openLink = (url) => {
    window.open(url, "_blank");
  };

  const onClickDownload = async () => {
    showLoadingDialog();
    try {
      let response;
      if (id) {
        response = await axios.get(`${BASE_URL}permohonan/get_letter/${id}`, {
          headers: {
            Authorization: token,
          },
          responseType: "blob",
        });
        hideLoadingDialog();
        // download the file and open it in new tab
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        const contentDisposition = response.headers["content-disposition"] || response.headers.get("content-disposition");
        let fileName = `surat_permohonan_${id}`;
        if (contentDisposition) {          
          const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (fileNameMatch != null && fileNameMatch[1]) { 
            fileName = fileNameMatch[1].replace(/['"]/g, '');
          }
        }
        const fileType = response.headers['content-type'];
        link.setAttribute("download", `${fileName}.${fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ? 'docx' : fileType.split('/')[1]}`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } else {
        throw "id not found!";
      }
    } catch (error) {
      console.log("ERROR", error);
      hideLoadingDialog();
      showFailedDialog({
        title: "Oops!",
        msg: error?.response?.data?.message || "Gagal mendownload data!",
      });
    }
  };

  return (
    <Card.Body>
      {isLoading ? (
        <p>Loading</p>
      ) : isError ? (
        <p>Oops, something went wrong!</p>
      ) : (
        <Form onSubmit={handleSubmit}>
          <Row>
            {/* Show when the status_verifikasi is not 1, means it is revised or rejected */}
            {formDisable &&
            (dataPermohonan.status_verifikasi === "2" ||
              dataPermohonan.status_verifikasi === "3") ? (
              <Col md={12} className="mb-3">
                <Card bg="danger" text="white">
                  <Card.Header>Balasan Pengajuan</Card.Header>
                  <Card.Body>
                    <Row>
                      <Col md={12} className="mb-3">
                        <Form.Group id="balasan">
                          <Form.Label>Balasan</Form.Label>
                          <Form.Control
                            required
                            type="text"
                            placeholder="-"
                            name="balasan"
                            disabled={true}
                            value={
                              dataPermohonan.status_verifikasi === "2"
                                ? "Revisi"
                                : "Ditolak"
                            }
                          />
                        </Form.Group>
                      </Col>
                      {formDisable &&
                      dataPermohonan.catatan &&
                      dataPermohonan.status_verifikasi === "2" ? (
                        <Col md={12}>
                          <Form.Group id="catatan">
                            <Form.Label>Catatan</Form.Label>
                            <Form.Control
                              required
                              type="text"
                              placeholder="-"
                              name="catatan"
                              disabled={true}
                              value={dataPermohonan.catatan}
                            />
                          </Form.Group>
                        </Col>
                      ) : null}
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            ) : null}
            {formDisable && dataPermohonan.nomor_permohonan ? (
              <Col md={12} className="mb-3">
                <Form.Group id="nomor_permohonan">
                  <Form.Label>Nomor Permohonan</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="nomor_permohonan"
                    name="nomor_permohonan"
                    disabled={true}
                    value={dataPermohonan.nomor_permohonan || ""}
                  />
                </Form.Group>
              </Col>
            ) : null}
            <Col md={12} className="mb-3">
              <Form.Group id="nim">
                <Form.Label>NIM</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="NIM"
                  name="nim"
                  disabled={formDisable || formDisableNotAdmin}
                  value={dataPermohonan.nim || ""}
                  onChange={(e) =>
                    setDataPermohonan({
                      ...dataPermohonan,
                      nim: e.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group id="nama">
                <Form.Label>Nama</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Nama"
                  name="nama"
                  disabled={formDisable || formDisableNotAdmin}
                  value={dataPermohonan.nama || ""}
                  onChange={(e) =>
                    setDataPermohonan({
                      ...dataPermohonan,
                      nama: e.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group id="id_layanan">
                <Form.Label>Kategori Layanan</Form.Label>
                <Select
                  options={dataLayanan}
                  placeholder="Pilih kategori layanan"
                  required
                  value={dataLayanan?.find(
                    (e) => e.value.id === dataPermohonan.id_layanan
                  )}
                  isDisabled={formDisable}
                  isLoading={isLoadingLayananList}
                  onChange={(e) => {
                    setDataPermohonan({
                      ...dataPermohonan,
                      id_layanan: e.value.id,
                      kode_layanan: e.value.kode,
                    });
                  }}
                />
              </Form.Group>
            </Col>
            {isLoadingLayananFieldList ? (
              <Col md={12} className="mb-3">
                <p>Loading...</p>
              </Col>
            ) : (
              (dataLayananField?.data || []).map((item, i) => {
                const dataField = fieldList.find(
                  (e) => e.id_field === item.id_field
                );
                return (
                  <Col key={item.id} md={12} className="mb-3">
                    <Form.Group id={item.field_name}>
                      <Form.Label>
                        {item.field_label}
                        {!item.required ? " (Opsional)" : ""}
                      </Form.Label>
                      <Form.Control
                        type={item.field_type}
                        placeholder="-"
                        name={item.field_name}
                        disabled={formDisable}
                        value={dataField?.value || ""}
                        onChange={(e) => {
                          const newData = {
                            id_field: item.id_field,
                            nama_field: item.field_name,
                            // [item.field_name]: e.target.value,
                            value: e.target.value,
                            status: dataField?.status || "0",
                          };
                          // check if the document is already save
                          if (
                            fieldList.find((e) => e?.id_field === item.id_field)
                          ) {
                            // Use map to create a new array with the updated item
                            const updatedItems = fieldList.map((field) => {
                              if (field.id_field === item.id_field) {
                                field = newData;
                                // Return a new object with the updated ones
                                return { ...field };
                              }
                              // For other items, return them as they are
                              return field;
                            });

                            // Set the state with the updated items array
                            setFieldList(updatedItems);
                          } else {
                            setFieldList([...fieldList, newData]);
                          }
                        }}
                      />
                    </Form.Group>
                  </Col>
                );
              })
            )}
            {isLoadingLayananDokumenList ? (
              <Col md={12} className="mb-3">
                <p>Loading...</p>
              </Col>
            ) : (
              (dataLayananDokumen?.data || []).map((item, i) => {
                const dataDokumen = dokumenList.find(
                  (e) => e.id_dokumen === item.id_dokumen
                );
                return (
                  <UploadComponent
                    key={i}
                    item={item}
                    dataDokumen={dataDokumen}
                    onFileChange={onFileChange}
                    formDisable={formDisable}
                    dataPermohonan={dataPermohonan}
                    userData={userData}
                  />
                );
              })
            )}
            <Col md={12} className="mb-3">
              <Form.Group id="keterangan">
                <Form.Label>Keterangan</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="-"
                  name="keterangan"
                  disabled={formDisable}
                  value={dataPermohonan.keterangan || ""}
                  onChange={(e) =>
                    setDataPermohonan({
                      ...dataPermohonan,
                      keterangan: e.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
            {formDisable && dataPermohonan.tanggal_permohonan ? (
              <Col md={12} className="mb-3">
                <Form.Group id="created_at">
                  <Form.Label>Tanggal Dibuat</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="-"
                    name="created_at"
                    disabled={true}
                    value={moment(dataPermohonan.tanggal_permohonan).format(
                      "DD MMM YYYY HH:mm:ss"
                    )}
                  />
                </Form.Group>
              </Col>
            ) : null}
            {formDisable &&
            dataPermohonan.tanggal_verifikasi &&
            dataPermohonan.status === "5" ? (
              <Col md={12} className="mb-3">
                <Form.Group id="tanggal_verifikasi">
                  <Form.Label>Tanggal Disetujui</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="-"
                    name="tanggal_verifikasi"
                    disabled={true}
                    value={moment(dataPermohonan.tanggal_verifikasi).format(
                      "DD MMM YYYY HH:mm:ss"
                    )}
                  />
                </Form.Group>
              </Col>
            ) : null}
          </Row>
          {formDisable ? (
            <div className="d-grid gap-2">
              {
                // check if the data is on approval request or it is already revised
                // and make sure the data isn't rejected by checking it's last verification
                // status_verifikasi => 1 = disetujui | 2 => revisi | 3 => ditolak
                dataPermohonan.status_verifikasi !== "3" &&
                ((userData?.id_role === dataPermohonan.role_status &&
                  !dataPermohonan.flag_revisi) ||
                  (dataPermohonan.flag_revisi &&
                    userData?.id === dataPermohonan.id_user)) ? (
                  <>
                    <Button
                      disabled={isLoading}
                      onClick={() =>
                        userData?.id !== dataPermohonan.id_user
                          ? setShowVerifModal(true)
                          : onAjukanClick(dataPermohonan.flag_revisi)
                      }
                    >
                      {userData?.id === dataPermohonan.id_user
                        ? dataPermohonan.flag_revisi
                          ? "Ajukan Ulang Permohonan"
                          : `Ajukan Permohonan`
                        : "Verifikasi"}
                    </Button>
                    <ModalVerificationPermohonanDialog
                      show={showVerifModal}
                      showFieldOnVerif={dataPermohonan.is_generated}
                      onClose={() => setShowVerifModal(false)}
                      cb={(status, reason) => onClickVerify(status, reason)}
                    />
                  </>
                ) : null
              }
              {/* TIMELINE BUTTON */}
              {dataPermohonan.status !== "0" ? (
                <>
                  <Button
                    disabled={isLoading}
                    variant="outline-primary"
                    onClick={() => setShowModalTimeline(true)}
                  >
                    Lihat Timeline
                  </Button>
                  <ModalPermohonanTimeline
                    id={id}
                    show={showModalTimeline}
                    onHide={() => setShowModalTimeline(false)}
                  />
                </>
              ) : null}
              {/* UPLOAD FILE VERIFIKASI BUTTON */}
              {dataPermohonan.status === "5" ? (
                <Row>
                  {userData?.id_role === "HA04" &&
                  (!dataPermohonan.is_generated || dataPermohonan.path_dokumen_upload_final) ? (
                    <Col>
                      <Form.Control
                        ref={fileVerifInputRef}
                        onChange={(event) =>
                          onFileVerifChange(event.target.files[0])
                        }
                        type="file"
                        className="d-none"
                        accept=".pdf,.jpg,.jpeg,.png"
                      />
                      <div className="d-grid">
                        <Button
                          variant="success"
                          onClick={() => {
                            fileVerifInputRef.current.click();
                          }}
                        >
                          <FontAwesomeIcon
                            icon={
                              dataPermohonan.path_dokumen_upload_final
                                ? faEdit
                                : faUpload
                            }
                            className="me-2"
                          />
                          {dataPermohonan.path_dokumen_upload_final
                            ? "Ubah File Verifikasi"
                            : "Upload File Verifikasi"}
                        </Button>
                      </div>
                    </Col>
                  ) : null}
                  {dataPermohonan.path_dokumen_upload_final ||
                  dataPermohonan.is_generated ? (
                    <Col
                      className="d-grid"
                      xs={
                        userData?.id_role === "HA04" &&
                        (!dataPermohonan.is_generated || dataPermohonan.path_dokumen_upload_final)
                          ? "auto"
                          : "12"
                      }
                    >
                      <Button
                        variant="outline-primary"
                        onClick={() => {
                          if (dataPermohonan.path_dokumen_upload_final) {
                            openLink(dataPermohonan.path_dokumen_upload_final);
                          } else {
                            onClickDownload();
                          }
                        }}
                      >
                        {userData?.id_role === "HA04" &&
                        (!dataPermohonan.is_generated || dataPermohonan.path_dokumen_upload_final) ? (
                          <FontAwesomeIcon icon={faEye} />
                        ) : (
                          "Download"
                        )}
                      </Button>
                    </Col>
                  ) : null}
                </Row>
              ) : null}
            </div>
          ) : (
            <div>
              {id ? (
                <Button type="submit" disabled={isLoading}>
                  Update
                </Button>
              ) : (
                <Button type="submit" disabled={isLoading}>
                  Simpan
                </Button>
              )}
            </div>
          )}
        </Form>
      )}
    </Card.Body>
  );
};

const UploadComponent = ({
  item, // data from the master
  dataDokumen, // data document that we have store into our system
  onFileChange,
  formDisable,
  dataPermohonan, // data from permohonan
  userData,
}) => {
  const fileInputRef = useRef(null);
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");

  const openLink = (url) => {
    window.open(url, "_blank");
  };

  const isAbleToReject =
    userData?.id_role === dataPermohonan.role_status &&
    dataPermohonan.flag_revisi;

  function isDisableForm() {
    let result = true;
    if (formDisable) {
      // check untuk mahasiswa
      if (
        userData?.id_role === "HA05" &&
        dataPermohonan?.status === "1" &&
        dataPermohonan.flag_revisi &&
        (dataDokumen?.status === null || dataDokumen?.status === "2")
      ) {
        result = false;
      }
      // check untuk staff
      else if (isAbleToReject) {
        // disable if the dokumen is already rejected
        if (dataDokumen?.status === null || dataDokumen?.status === "2")
          result = true;
        // make it false when it hasn't rejected yet
        else result = false;
      }
      // // if there is no condition to update a file.
      // // make it true;
      // else {
      //   result = true;
      // }
    } else {
      result = false;
    }
    return result;
  }

  const revisedDokumen = () => {
    showAlertDialog({
      title: "Perlu Revisi?",
      msg: `apakah anda yakin ingin menandai revisi pada dokumen ini?`,
      confirmButtonText: "Revisi",
      onConfirm: async () => {
        showLoadingDialog();
        try {
          await axios.post(
            `${BASE_URL}permohonan/verifikasi_perdokumen`,
            {
              id: dataDokumen.id,
              status: "2", // revised
            },
            {
              headers: {
                Authorization: token,
              },
            }
          );
          hideLoadingDialog();
          showSuccessDialog({
            title: "Berhasil!",
            msg: "Berhasil menandai data!",
          });
          dispatch(reset());
          dispatch(GetSinglePermohonan({ id: dataPermohonan.id, token }));
        } catch (error) {
          console.log("ERROR", error);
          hideLoadingDialog();
          showFailedDialog({
            title: "Oops!",
            msg: error?.response?.data?.message || "Gagal menandai data!",
          });
        }
      },
    });
  };

  return (
    <Col md={12} className="mb-3">
      <Form.Group controlId="formFile">
        <Form.Label>
          {item.nama_dokumen}
          <span style={{ color: "red" }}>{item.is_mandatory ? "*" : ""}</span>
        </Form.Label>
        {`${dataPermohonan?.status}` === "1" &&
        `${dataDokumen?.status}` === "2" ? (
          <Alert sm="true" variant="danger">
            File telah ditolak, mohon upload ulang dengan data yang sesuai!
          </Alert>
        ) : null}
        <Row>
          <Col>
            <Form.Control
              required
              type="text"
              placeholder="Pilih file untuk diupload"
              name="dokumen"
              disabled={true}
              value={dataDokumen?.dokumen || ""}
            />
          </Col>
          <Col xs="auto">
            <Form.Control
              ref={fileInputRef}
              onChange={(event) => onFileChange(event.target.files[0], item)}
              type="file"
              className="d-none"
              // disable when the form is disable and the document is not rejected
              disabled={isDisableForm()}
              accept=".pdf,.jpg,.jpeg,.png"
            />
            <Button
              variant={
                isAbleToReject && dataDokumen?.status === "0"
                  ? "danger"
                  : "primary"
              }
              // disable when the form is disable and the document is not rejected
              disabled={isDisableForm()}
              onClick={() => {
                if (isAbleToReject) {
                  revisedDokumen();
                } else {
                  fileInputRef.current.click();
                }
              }}
            >
              <FontAwesomeIcon
                icon={
                  isAbleToReject
                    ? faTimesCircle
                    : dataDokumen?.dokumenFullPath
                    ? faEdit
                    : faUpload
                }
              />
            </Button>
          </Col>
          {dataDokumen?.dokumenFullPath ? (
            <Col xs="auto">
              <Button
                variant="outline-primary"
                onClick={() => openLink(dataDokumen?.dokumenFullPath)}
              >
                <FontAwesomeIcon icon={faEye} />
              </Button>
            </Col>
          ) : null}
        </Row>
      </Form.Group>
    </Col>
  );
};

export default FormPembayaranVAPage;
